"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Util_1 = require("../../Util");

var EntryHandlerKeyword_1 = require("./EntryHandlerKeyword");

var EntryHandlerPredicate_1 = require("../EntryHandlerPredicate");
/**
 * Handles @graph entries.
 */


var EntryHandlerKeywordType =
/*#__PURE__*/
function (_EntryHandlerKeyword_) {
  _inherits(EntryHandlerKeywordType, _EntryHandlerKeyword_);

  function EntryHandlerKeywordType() {
    _classCallCheck(this, EntryHandlerKeywordType);

    return _possibleConstructorReturn(this, _getPrototypeOf(EntryHandlerKeywordType).call(this, '@type'));
  }

  _createClass(EntryHandlerKeywordType, [{
    key: "handle",
    value: function () {
      var _handle = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(parsingContext, util, key, keys, value, depth) {
        var keyOriginal, parentKey, context, predicate, reverse, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, element, type, _type;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                keyOriginal = keys[depth];
                _context.next = 3;
                return util.unaliasKeywordParent(keys, depth);

              case 3:
                parentKey = _context.sent;
                _context.next = 6;
                return parsingContext.getContext(keys);

              case 6:
                context = _context.sent;
                predicate = util.rdfType;
                reverse = Util_1.Util.isPropertyReverse(context, keyOriginal, parentKey); // Handle multiple values if the value is an array

                if (!Array.isArray(value)) {
                  _context.next = 40;
                  break;
                }

                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 13;
                _iterator = value[Symbol.iterator]();

              case 15:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 24;
                  break;
                }

                element = _step.value;
                type = util.createVocabOrBaseTerm(context, element);

                if (!type) {
                  _context.next = 21;
                  break;
                }

                _context.next = 21;
                return EntryHandlerPredicate_1.EntryHandlerPredicate.handlePredicateObject(parsingContext, util, keys, depth, parentKey, predicate, type, reverse);

              case 21:
                _iteratorNormalCompletion = true;
                _context.next = 15;
                break;

              case 24:
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t0 = _context["catch"](13);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 30:
                _context.prev = 30;
                _context.prev = 31;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 33:
                _context.prev = 33;

                if (!_didIteratorError) {
                  _context.next = 36;
                  break;
                }

                throw _iteratorError;

              case 36:
                return _context.finish(33);

              case 37:
                return _context.finish(30);

              case 38:
                _context.next = 44;
                break;

              case 40:
                _type = util.createVocabOrBaseTerm(context, value);

                if (!_type) {
                  _context.next = 44;
                  break;
                }

                _context.next = 44;
                return EntryHandlerPredicate_1.EntryHandlerPredicate.handlePredicateObject(parsingContext, util, keys, depth, parentKey, predicate, _type, reverse);

              case 44:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[13, 26, 30, 38], [31,, 33, 37]]);
      }));

      function handle(_x, _x2, _x3, _x4, _x5, _x6) {
        return _handle.apply(this, arguments);
      }

      return handle;
    }()
  }]);

  return EntryHandlerKeywordType;
}(EntryHandlerKeyword_1.EntryHandlerKeyword);

exports.EntryHandlerKeywordType = EntryHandlerKeywordType;